<template>
  <AppCard :class="cn('p-5', props.class)">
    <div class="flex items-start justify-between gap-3">
      <div class="flex-1 min-w-0">
        <p class="text-xs font-medium text-muted-foreground uppercase tracking-wide truncate">{{ label }}</p>
        <p v-if="!loading" class="mt-1.5 text-2xl font-bold text-foreground tabular-nums">{{ value }}</p>
        <AppSkeleton v-else class="mt-1.5 h-8 w-24" />
        <p v-if="sub" class="mt-1 text-xs text-muted-foreground truncate">{{ sub }}</p>
      </div>
      <div
        v-if="icon"
        :class="cn('rounded-lg p-2.5 shrink-0', iconBg)"
      >
        <component :is="icon" :class="cn('h-5 w-5', iconColor)" />
      </div>
    </div>
    <div v-if="trend !== undefined" class="mt-3 flex items-center gap-1 text-xs font-medium" :class="trend >= 0 ? 'text-emerald-600' : 'text-red-600'">
      <TrendingUp v-if="trend >= 0" class="h-3 w-3" />
      <TrendingDown v-else class="h-3 w-3" />
      <span>{{ Math.abs(trend) }}%</span>
      <span class="text-muted-foreground font-normal ml-1">vs last month</span>
    </div>
  </AppCard>
</template>

<script setup>
import { TrendingUp, TrendingDown } from 'lucide-vue-next'
import { cn } from '@/lib/utils'
import AppCard from './AppCard.vue'
import AppSkeleton from './AppSkeleton.vue'

const props = defineProps({
  label:     { type: String,  required: true },
  value:     { type: [String, Number], default: '—' },
  sub:       { type: String,  default: '' },
  icon:      { type: [Object, Function], default: null },
  iconBg:    { type: String,  default: 'bg-primary/10' },
  iconColor: { type: String,  default: 'text-primary' },
  trend:     { type: Number,  default: undefined },
  loading:   { type: Boolean, default: false },
  class:     { type: String,  default: '' },
})
</script>
